<template>
  <div>
    <div
      v-if="blocks.length"
    >
      <div class="grid auto-cols-auto gap-4 grid-cols-3 lg:grid-cols-9">
        <CategoryCard
          v-for="block in blocks"
          :key="block.title"
          :title="block.title"
          :link="block.link"
          :image="block.image"
          :alt-image-text="block.altImageText"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import CategoryCard from '~/components/molecules/CategoryCard/CategoryCard.vue';
import type { CategoryCard as CategoryCardType } from '~~/types/cms/CategoryCard';

export default defineComponent({
  name: 'CategoryCards',
  components: {
    CategoryCard,
  },
  props: {
    blocks: {
      type: Array as PropType<CategoryCardType[]>,
      default: () => {

        return [];
      
      },
      validator: (categoryItems: CategoryCardType[]) => {

        return categoryItems.every((block: CategoryCardType) => {

          return block.link && block.title && block.image;
        
        });
      
      },
    },
  },
});
</script>
